import { notification } from "antd";
import styles from "./DataUploadNotification.module.scss";

function DataUploadNotification({ description }: { description: React.ReactNode }) {
  notification.open({
    className: styles.notification,
    duration: 20,
    message: "",
    description: description,
    placement: "top",
    showProgress: true,
  });
}

export default DataUploadNotification;
